module.exports = __webpack_public_path__ + "img/plastics-img-1.4e94e5e1.png";